import { render, staticRenderFns } from "./BillingStatusTab.vue?vue&type=template&id=89122bb0&scoped=true"
import script from "./BillingStatusTab.vue?vue&type=script&lang=js"
export * from "./BillingStatusTab.vue?vue&type=script&lang=js"
import style0 from "./BillingStatusTab.vue?vue&type=style&index=0&id=89122bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89122bb0",
  null
  
)

export default component.exports